import React from "react";
import { Checkbox } from "antd";

export const $CheckboxGroup = Checkbox.Group;
